// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangePasswordPage_container__1ClNL"};